export async function completeResearchChat(
  hitAxios,
  { messages, systemPrompt, temperature, documents, file },
) {
  const payloadMessages = (messages || []).map((m) => ({
    role: m.role,
    content: String(m.content || "").trim(),
    attachments: m.attachments || undefined,
  }));

  let obj;
  if (file) {
    const form = new FormData();
    form.append("messages", JSON.stringify(payloadMessages));
    if (systemPrompt) form.append("system_prompt", systemPrompt);
    if (temperature != null) form.append("temperature", String(temperature));
    if (documents?.length) form.append("documents", JSON.stringify(documents));
    form.append("document", file, file.name);
    obj = form;
  } else {
    obj = {
      messages: payloadMessages,
      system_prompt: systemPrompt || undefined,
      temperature,
      documents: documents?.length ? documents : undefined,
    };
  }

  const res = await hitAxios({
    path: "/api/research-chat/complete",
    post: true,
    obj,
    showLoading: false,
    showSnackbar: false,
    timeout: 180000,
  });

  if (!res?.data?.success) {
    throw new Error(res?.data?.msg || "Research request failed.");
  }

  return res.data.data;
}
